import './contact.less'

import {DOMAttrs, m, wrap} from '@codeurs/front'
import {ErrorMessage, Field, FieldArray, Form, Formik} from 'formik'
import requestService from 'mithril/request/request'
import {Component, FunctionComponent} from 'react'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
import {Layout} from 'views/layout'
import {Theme} from 'views/theme'

const request = requestService(window, Promise).request

const styles = style('contact', ['field', 'schools'])

const ContactField: FunctionComponent<DOMAttrs> = ({label, name, ...attrs}) => (
	<div class={styles.field}>
		<div>{label}</div>
		<Field class={styles.field('input')} name={name} {...attrs} />
		<ErrorMessage class={styles.field('error')} name={name} />
	</div>
)

const PickSchools = () => (
	<FieldArray name="schools">
		{({form, push}) => (
			<div class={styles.schools}>
				{form.values.schools.map((school, index) => (
					<div class={styles.schools('row')}>
						<label>
							<ErrorMessage name={`schools[${index}].school`} />
							School waar je les geeft:
							<Field
								class={styles.field('input')}
								name={`schools[${index}].school`}
							/>
						</label>
						<label>
							<ErrorMessage name={`postal[${index}].postal`} />
							Postcode van de school:
							<Field
								class={styles.field('input')}
								name={`schools[${index}].postal`}
							/>
						</label>
						<div>Graad waar je les geeft:</div>
						<label class={styles.schools('label')}>
							<Field
								type="checkbox"
								value="lower"
								name={`schools[${index}].grades`}
							/>
							Lager onderwijs
						</label>
						<label class={styles.schools('label')}>
							<Field
								type="checkbox"
								value="first"
								name={`schools[${index}].grades`}
							/>
							Eerste graad middelbaar
						</label>
						<label class={styles.schools('label')}>
							<Field
								type="checkbox"
								value="second"
								name={`schools[${index}].grades`}
							/>
							Tweede graad middelbaar
						</label>
						<label class={styles.schools('label')}>
							<Field
								type="checkbox"
								value="third"
								name={`schools[${index}].grades`}
							/>
							Derde graad middelbaar
						</label>
					</div>
				))}
				<Theme.Button
					mod={{round: true, outline: true}}
					onClick={() => push({})}
				>
					Voeg nog een school toe
				</Theme.Button>
			</div>
		)}
	</FieldArray>
)

type School = {
	school?: string
	postal?: string
	grades?: Array<string>
}

const formSubmit = (req, cb) => ({values, setErrors}) =>
	request({data: values, ...req})
		.then(cb)
		.catch(error => {
			console.log(error)
			const errors = JSON.parse(error.message)
			setErrors(errors)
		})

type FormData = {
	schools: Array<School>
}

@wrap(Layout)
export class Contact extends Component {
	state = {isComplete: false}
	render() {
		const t = useTranslation()
		if (this.state.isComplete)
			return <Theme.Container>{t('contact.thanks')}</Theme.Container>
		return (
			<div class={styles}>
				<Theme.Container>
					<Formik<FormData>
						initialValues={{schools: [{}]}}
						onSubmit={(values: FormData, formik) =>
							request({
								method: 'POST',
								url: '/api/contact',
								data: values
							})
								.then(() => this.setState({isComplete: true}))
								.catch(error => formik.setErrors(JSON.parse(error.message)))
						}
					>
						<Form class={String(styles('form'))}>
							<ContactField
								name="name"
								required
								placeholder={t('contact.name')}
								label={t('contact.name')}
							/>
							<ContactField
								name="email"
								type="email"
								required
								placeholder={t('contact.email')}
								label={t('contact.email')}
							/>
							<ContactField
								as="textarea"
								name="question"
								required
								placeholder={t('contact.question')}
								label={t('contact.question')}
							/>
							<PickSchools />
							<div>
								<label>
									<Field name="optin" type="checkbox" required />
									Ik ben akkooord
								</label>
							</div>
							<Theme.Button as="button" type="submit">
								{t('contact.submit')}
							</Theme.Button>
						</Form>
					</Formik>
				</Theme.Container>
			</div>
		)
	}
}
